export default __webpack_public_path__ + "static/media/ro.6d757067.svg";